/* 🤖 this file was generated by svg-to-ts */
export const matIconDoorFront: {
  name: 'door-front';
  data: string;
} = {
  name: 'door-front',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14zm-4-8h2v2h-2v-2z"/></svg>`
};
